import gql from 'graphql-tag';

export const GetDepartmentByName = gql`
	query GetDepartmentByName($companyId: ID!, $name: String!) {
		getDepartmentByName(companyId: $companyId, name: $name) {
			items {
				id
				companyId
				name
				keywords
				externalDepartmentId
				active
				totalUsers
			}
			nextToken
		}
	}
`;

export const QueryDepartmentByCompanyIdName = gql`
	query QueryDepartmentByCompanyIdName($companyId: ID!, $name: String!) {
		queryDepartmentByName(companyId: $companyId, name: $name) {
			id
			companyId
			name
			keywords
			externalDepartmentId
			active
		}
	}
`;
